export default function EventoEspecialStep({ eventoInfo, onContinuar }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div>
        <h3
          style={{
            fontSize: 22,
            fontWeight: 900,
            color: '#0f172a',
            margin: 0,
            letterSpacing: '-0.02em',
          }}
        >
          {eventoInfo?.title || 'Evento Especial'}
        </h3>
        <p
          style={{
            fontSize: 13,
            color: '#64748b',
            fontWeight: 500,
            marginTop: 6,
          }}
        >
          Seu ingresso para essa edição
        </p>
      </div>

      <div
        style={{
          borderRadius: 16,
          border: '2px solid #ff2d6c',
          overflow: 'hidden',
          background: '#fff',
          boxShadow: '0 4px 12px rgba(255,45,108,0.1)',
        }}
      >
        {/* Header com gradiente */}
        <div
          style={{
            height: 8,
            background: 'linear-gradient(135deg, #ff2d6c, #e02059)',
          }}
        />

        <div
          style={{
            padding: '24px 20px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <div
            style={{
              fontSize: 11,
              color: '#64748b',
              fontWeight: 500,
              padding: '20px',
              background: '#f8fafc',
              borderRadius: 12,
              border: '1px solid #e2e8f0',
              display: 'grid',
              gridTemplateColumns: '1fr auto',
              gap: 16,
              alignItems: 'center',
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  color: '#94a3b8',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  marginBottom: 4,
                }}
              >
                Valor do ingresso
              </div>
              <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 'clamp(13px, 4vw, 16px)', display: 'block' }}>
                R${' '}
                {((eventoInfo?.amountInCents || 0) / 100)
                  .toFixed(2)
                  .replace('.', ',')}
              </span>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onContinuar}
        style={{
          width: '100%',
          padding: '16px 0',
          borderRadius: 99,
          border: 'none',
          cursor: 'pointer',
          background: 'linear-gradient(135deg, #ff2d6c, #e02059)',
          color: '#fff',
          fontSize: 12,
          fontWeight: 900,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          transition: 'all 0.2s ease',
          boxShadow: '0 6px 16px rgba(255,45,108,0.32)',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.01)';
          e.target.style.boxShadow = '0 8px 24px rgba(255,45,108,0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 6px 16px rgba(255,45,108,0.32)';
        }}
      >
        Continuar com este Ingresso →
      </button>
    </div>
  );
}
